<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">บันทึกข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_delete === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-5">
          <div class="text-center mb-3"><b>แบบฟอร์มคำร้องของลูกค้า</b></div>
          <div class="grid_header">
            <div class="refund_half font_mobile">
              <div class="grid_flex">
                <div class="pr-2">วันที่ทำเรื่องคืน</div>
                <div>{{ refund.created_date }}</div>
              </div>
              <div class="grid_flex">
                <div class="pr-2">หมายเลขการคืน :</div>
                <div>{{ refund.refund_code }}</div>
              </div>
            </div>
            <div class="text-right">
              <span v-if="refund.refund_status === 0 && refund.user_type !== 'พาร์ทเนอร์'"
                class="bg_success_tag">คำร้องใหม่</span>
              <span v-else-if="refund.refund_status === 0 && refund.user_type === 'พาร์ทเนอร์'"
                class="bg_warning_tag">คำร้องใหม่</span>
              <span v-else-if="refund.refund_status === 1" class="bg_refund_tag">รอลูกค้าส่งคืนสินค้า</span>
              <span v-else-if="refund.refund_status === 2" class="bg_warning_tag">ได้รับสินค้าส่งคืน</span>
              <span v-else-if="refund.refund_status === 3" class="bg_red_tag">ปฎิเสธการรับคืน</span>
              <span v-else-if="refund.refund_status === 4" class="bg_success_tag">เสร็จสิ้น</span>
            </div>
          </div>
          <div class="pa-2 mt-3">
            <v-divider />
            <v-data-table class="color_table_1" :headers="headers" :items="data_list" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="pa-3">
                    <div class="image_grid">
                      <div class="mx-auto">
                        <v-img height="64" width="64" max-width="64" v-if="dataDetail.item.product_picture !== null"
                          :lazy-src="img_holder" :src="dataDetail.item.product_picture" class="preview mx-auto"></v-img>
                        <v-img height="64" width="64" max-width="64" v-else-if="dataDetail.item.product_picture === null"
                          :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                      </div>
                      <div class="grey--text">
                        <div class="pl-7 pa-2 font_mobile black--text">{{ dataDetail.item.product_name }}</div>
                        <div v-if="dataDetail.item.lot_no !== null && dataDetail.item.promotion_exp_id !== null"
                          class="pl-7 pa-2 mr-14 table_flex">
                          <small>ล็อต: {{ dataDetail.item.lot_no }}</small>
                          <small>วันหมดอายุ: {{ dataDetail.item.promotion_exp_id }}</small>
                        </div>
                        <div v-else class="pl-7 pa-2 mr-14 table_flex">
                          <small>ล็อต: -</small>
                          <small>วันหมดอายุ: -</small>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_price(dataDetail.item.cost) }}</div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_number(dataDetail.item.quantity) }} {{ dataDetail.item.unit_name }}
                    </div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_price(dataDetail.item.total) }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div class="pa-2 mt-2 font_mobile_2">
            <div class="d-flex">
              <div class="black--text pr-2">สาเหตุการคืน</div>
              <div class="grey--text">{{ refund.refund_reason }}</div>
            </div>
          </div>
          <div v-if="refund.user_type !== 'พาร์ทเนอร์'" class="pa-2 mt-2 font_mobile_2">
            <div class="black--text pr-2">กรุณาแนบรูปภาพสินค้าที่ต้องการส่งคืน</div>
            <div class="image_half">
              <div>
                <div style="color: red;">* ภาพสินค้าบริเวร เลขล็อตและวันหมดอายุ</div>
                <div>
                  <v-img height="256" width="256" max-width="256" :lazy-src="img_holder" :src="refund.picture_lot"
                    class="preview margin_auto"></v-img>
                </div>
              </div>
              <div>
                <div style="color: red;">* ภาพความผิดปกติของสินค้า</div>
                <div>
                  <v-img height="256" width="256" max-width="256" :lazy-src="img_holder" :src="refund.picture_damage"
                    class="preview margin_auto"></v-img>
                </div>
              </div>
            </div>
          </div>
          <div v-if="refund.user_type !== 'พาร์ทเนอร์'" class="pa-2 mt-2 font_mobile_2">
            <div class="d-flex">
              <div class="black--text pr-2">การคืนสินค้ากลับฟาร์มาแคร์</div>
              <div class="grey--text">ส่งพัสดุ ( เลขพัสดุ : {{ refund.refund_tracking }} )</div>
            </div>
          </div>
          <div v-if="refund.refund_fix === 2 && refund.user_type !== 'พาร์ทเนอร์'" class="pa-2 mt-2 font_mobile_2">
            <div class="grid_issue">
              <div>
                <div v-if="refund.user_type == 'ลูกค้าส่ง(เครดิต)'" class="black--text">วิธีการแก้ไข <span
                    class="grey--text">คืนเครดิต</span></div>
                <div v-else class="black--text">วิธีการแก้ไข <span class="grey--text">{{ refund.refund_fix_text }}</span>
                </div>
              </div>
              <div v-if="refund.user_type !== 'ลูกค้าส่ง(เครดิต)'">
                <div>ชื่อบัญชี {{ refund.refund_fix_bank_account_name }}</div>
                <div class="issue_half">
                  <div>ธนาคาร {{ refund.refund_fix_bank_name }}</div>
                  <div>เลขที่บัญชี {{ refund.refund_fix_bank_number }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="refund.refund_fix === 1 && refund.user_type !== 'พาร์ทเนอร์'" class="pa-2 mt-2 font_mobile_2">
            <div class="grid_issue">
              <div>
                <div v-if="refund.user_type == 'ลูกค้าส่ง(เครดิต)'" class="black--text">วิธีการแก้ไข <span
                    class="grey--text">คืนเครดิต</span></div>
                <div v-else class="black--text">วิธีการแก้ไข <span class="grey--text">{{ refund.refund_fix_text }}</span>
                </div>

              </div>
              <div v-if="refund.user_type !== 'ลูกค้าส่ง(เครดิต)'">
                <div class="issue_half">
                  <div>ชื่อ {{ refund.refund_fix_name }}</div>
                  <div>เบอร์โทร {{ refund.refund_fix_tel }}</div>
                </div>
                <div>ที่อยู่ {{ refund.refund_fix_address }} {{ refund.refund_fix_sub_address }}</div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <!-- <v-card elevation="6" class="mt-5">
        <div class="pa-5">
          <div class="text-center mb-3"><b>ประวัติคำสั่งซื้อข้อมูลในระบบ</b></div>
          <div class="grid_header_2">
            <div class="refund_half font_mobile">
              <div class="d-flex">
                <div class="pr-2">หมายเลขคำสั่งซื้อ :</div>
                <div>{{ order.order_code }}</div>
              </div>
              <div class="d-flex">
                <div class="pr-2">วันที่จัดส่ง :</div>
                <div>{{ order.created_date }}</div>
              </div>
            </div>
          </div>
          <div class="pa-2 mt-3">
            <v-divider />
            <v-data-table class="color_table_2" :headers="headers_list" :items="history_list" :footer-props="footer_Props"
              mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td class="pa-3">
                    <div class="image_grid">
                      <div class="mx-auto py-2">
                        <v-img height="64" width="64" max-width="64" v-if="dataDetail.item.product_picture !== null"
                          :lazy-src="img_holder" :src="dataDetail.item.product_picture" class="preview mx-auto"></v-img>
                        <v-img height="64" width="64" max-width="64" v-if="dataDetail.item.product_picture === null"
                          :lazy-src="img_holder" :src="img_holder" class="preview mx-auto"></v-img>
                      </div>
                      <div class="grey--text">
                        <div class="pl-7 pa-2 font_mobile black--text">{{ dataDetail.item.product_name }}</div>
                        <div v-if="dataDetail.item.lot_no !== null && dataDetail.item.promotion_exp_id !== null"
                          class="pl-7 pa-2 mr-14 table_flex">
                          <small>ล็อต: {{ dataDetail.item.lot_no }}</small>
                          <small>วันหมดอายุ: {{ dataDetail.item.promotion_exp_id }}</small>
                        </div>
                        <div v-else class="pl-7 pa-2 mr-14 table_flex">
                          <small>ล็อต: -</small>
                          <small>วันหมดอายุ: -</small>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_price(dataDetail.item.cost) }}</div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_number(dataDetail.item.quantity) }} {{ dataDetail.item.unit_name }}
                    </div>
                  </td>
                  <td>
                    <div class="font_mobile">{{ format_price(dataDetail.item.total) }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </div>
      </v-card> -->
      <div v-if="refund.refund_status === 0" class="text-center mt-8 pb-4">
        <v-btn height="50" class="white--text grad-success-bg btn_mobile mr-2" @click="confirm_modal = true"
          type="button">อนุมัติ</v-btn>
        <v-btn height="50" class="white--text grad-danger-bg btn_mobile mr-2" @click="refuse_modal = true"
          type="button">ปฏิเสธคำร้อง</v-btn>
      </div>
      <div v-else-if="refund.refund_status === 1" class="text-center mt-8 pb-4">
        <v-btn height="50" class="white--text grad-grey-bg btn_mobile_2 mr-2" @click="confirm_receive_product = true"
          type="button">ได้รับสินค้าจากลูกค้าเรียบร้อยแล้ว</v-btn>
      </div>
      <div v-else-if="refund.refund_status === 2 && refund.refund_fix === 1" class="text-center mt-8 pb-4">
        <v-btn height="50" class="white--text grad-warning-bg btn_mobile mr-2" @click="detailEditBillLots()"
          type="button">
          <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
        </v-btn>
        <v-btn height="50" class="white--text grad-main-bg btn_mobile mr-2" @click="print_refund"
          type="button">พิมพ์ใบส่งสินค้าคืน</v-btn>
        <v-btn height="50" class="white--text grad-success-bg btn_mobile mr-2" @click="tracking_modal = true"
          type="button">เลขที่พัสดุ</v-btn>
      </div>
      <div v-else-if="refund.refund_status === 2 && refund.refund_fix === 2 && refund.user_type === 'ลูกค้าส่ง(เครดิต)'"
        class="text-center mt-8 pb-4">
        <v-btn height="50" class="white--text grad-warning-bg btn_mobile_2 mr-2" @click="refund_cash_partner"
          type="button">คืนเครดิตลูกค้า</v-btn>
      </div>
      <div v-else-if="refund.refund_status === 2 && refund.refund_fix === 2" class="text-center mt-8 pb-4">
        <v-btn height="50" class="white--text grad-warning-bg btn_mobile_2 mr-2" @click="refund_to_cash = true"
          type="button">คืนเงินลูกค้า</v-btn>
      </div>
      <!-- Timeline Card -->
      <v-card v-if="refund.refund_status !== 3" elevation="6" class="mt-3">
        <div class="pa-5">
          <div class="text-left mb-3"><b>ประวัติการดำเนินการ</b></div>
          <div class="font_mobile">
            <!-- Step 1 -->
            <div v-if="refund.user_confirm_id !== null" class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_checked" :src="img_checked"
                  class="preview mx_auto"></v-img>
              </div>
              <!--              <div class="mt-2 mr-2">-->
              <!--                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time" class="preview mx_auto"></v-img>-->
              <!--              </div>-->
              <div class="mt_mobile">อนุมัติคำร้อง โดย {{ refund.user_confirm_id }} {{ refund.created_at }}</div>
            </div>
            <div v-else class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time"
                  class="preview mx_auto"></v-img>
              </div>
              <!--              <div class="mt-2 mr-2">-->
              <!--                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time" class="preview mx_auto"></v-img>-->
              <!--              </div>-->
              <div class="mt_mobile">อนุมัติคำร้อง โดย -</div>
            </div>
            <!-- Step 2 -->
            <div v-if="refund.user_received_id !== null" class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_checked" :src="img_checked"
                  class="preview mx_auto"></v-img>
              </div>
              <div class="mt_mobile">ได้รับสินค้าส่งคืน โดย {{ refund.user_received_id }} {{ refund.created_at }}</div>
            </div>
            <div v-else class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time"
                  class="preview mx_auto"></v-img>
              </div>
              <div class="mt_mobile">ได้รับสินค้าส่งคืน โดย -</div>
            </div>
            <!-- Step 3 -->
            <div v-if="refund.user_type !== 'พาร์ทเนอร์'">
              <div v-if="refund.user_transfer_id !== null" class="d-flex">
                <div class="mt-2 mr-2">
                  <v-img height="32" width="32" max-width="32" :lazy-src="img_checked" :src="img_checked"
                    class="preview mx_auto"></v-img>
                </div>
                <div class="mt_mobile">คืน สินค้า/เงิน ให้ลูกค้า โดย {{ refund.user_transfer_id }} {{ refund.created_at }}
                </div>
              </div>
              <div v-else class="d-flex">
                <div class="mt-2 mr-2">
                  <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time"
                    class="preview mx_auto"></v-img>
                </div>
                <div class="mt_mobile">คืน สินค้า/เงิน ให้ลูกค้า โดย -</div>
              </div>
            </div>
            <!-- Picture Step -->
            <div v-if="refund.refund_fix === 2">
              <div v-if="refund.slips !== null" class="pa-2">
                <v-img height="256" width="256" max-width="256" :lazy-src="picture_holder" :src="refund.slips"
                  class="preview mx_auto"></v-img>
              </div>
            </div>
            <div class="ml-11" v-else-if="refund.refund_fix === 1">
              <div v-if="refund.tracking_number !== null">หมายเลขพัสดุ : {{ refund.tracking_number }}</div>
            </div>
            <!-- Step 4 -->
            <div v-if="refund.user_complete_id !== null" class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_checked" :src="img_checked"
                  class="preview mx_auto"></v-img>
              </div>
              <div class="mt_mobile">เสร็จสิ้น โดย {{ refund.user_complete_id }} {{ refund.created_at }}</div>
            </div>
            <div v-else class="d-flex">
              <div class="mt-2 mr-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time"
                  class="preview mx_auto"></v-img>
              </div>
              <div class="mt_mobile">เสร็จสิ้น โดย -</div>
            </div>
          </div>
        </div>
      </v-card>
      <!-- Cancel Card -->
      <v-card v-else elevation="6" class="mt-3">
        <div class="pa-5">
          <div class="text-left mb-3"><b>ประวัติการดำเนินการ</b></div>
          <div class="font_mobile">
            <div v-if="refund.user_cancel_id !== null" class="d-flex">
              <div class="mt-2 mr-2 pt-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_cancel" :src="img_cancel"
                  class="preview mx_auto"></v-img>
              </div>
              <div>
                <div class="mt-2">ปฎิเสธิคำร้อง โดย {{ refund.user_cancel_id }} {{ refund.cancel_date }}</div>
                <div class="mt-2">เหตุผล : {{ refund.cancel_note }}</div>
              </div>
            </div>
            <div v-else class="d-flex">
              <div class="mt-2 mr-2 pt-2">
                <v-img height="32" width="32" max-width="32" :lazy-src="img_time" :src="img_time"
                  class="preview mx_auto"></v-img>
              </div>
              <div>
                <div class="mt-2">ปฎิเสธิคำร้อง โดย -</div>
                <div class="mt-2">เหตุผล : -</div>
              </div>
            </div>
          </div>
        </div>
      </v-card>
      <!-- confirm -->
      <v-dialog v-model="confirm_modal" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยืนยันการอนุมัติคำร้องขอคืนสินค้า
              </v-card-title>
              <v-btn icon class="ma-4" @click="confirm_modal = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <v-card-subtitle>
                <div class="mb-3">ท่านแน่ใจใช่ไหม ที่อนุมัติคำร้องการคืนสินค้านี้</div>
                <div class="mb-3">เมื่ออนุมัติคำร้อง ระบบจะอัพเดทสถานะไปยังลูกค้าให้ทำการส่งคืนสินค้าทันที</div>
              </v-card-subtitle>
              <div class="text-right mt-8 pb-4">
                <v-btn height="50" class="white--text grad-success-bg mr-2" @click="claim_confirm"
                  type="button">ยืนยัน</v-btn>
                <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="confirm_modal = false"
                  type="button">ยกเลิก</v-btn>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-dialog>
      <!-- refuse -->
      <v-dialog v-model="refuse_modal" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                ยืนยันปฎิเสธิคำร้องขอคืนสินค้า
              </v-card-title>
              <v-btn icon class="ma-4" @click="refuse_modal = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-form ref="refuse_form" @submit.prevent="claim_refuse">
              <v-card-text>
                <v-card-subtitle>
                  <div class="mb-3">เหตุใดคำร้องการคืนสินค้าของลูกค้าถูกปฎิเสธ ?</div>
                  <div class="mb-3">
                    <v-textarea color="#86bc3a" label="กรุณากรอกเหตุผลการปฎิเสธ"
                      :rules="[v => !!v || 'กรุณากรอกเหตุผลการปฎิเสธ']" hide-details="auto" v-model="refuse_note"
                      outlined></v-textarea>
                  </div>
                  <div class="mb-3" style="color: red;">หมายเหตุ : เหตุผลของท่านจะเป็นข้อความตอบกลับไปยังลูกค้า</div>
                </v-card-subtitle>
                <div class="text-right mt-8 pb-4">
                  <v-btn height="50" class="white--text grad-success-bg mr-2" type="submit">ยืนยัน</v-btn>
                  <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="refuse_modal = false"
                    type="button">ยกเลิก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <!-- confirm_receive_product -->
      <v-dialog v-model="confirm_receive_product" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-form ref="confirm_product" @submit.prevent="confirm_product">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยืนยันการรับสินค้าจากลูกค้า
                </v-card-title>
                <v-btn icon class="ma-4" @click="confirm_receive_product = false">
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-card-subtitle>
                  <div class="mb-3">กรุณาเลือกคลังที่ต้องการนำเข้า</div>
                  <div class="grid_full">
                    <v-autocomplete clearable color="#86bc3a" :items="warehouse_list" item-text="warehouse_name"
                      item-value="warehouse_id" v-model="warehouse_type" label="กรุณาเลือกคลัง"
                      :rules="[v => !!v || 'กรุณาเลือกคลัง']" prepend-inner-icon="mdi-warehouse" hide-details="auto"
                      outlined></v-autocomplete>
                  </div>
                  <!--                <div class="mb-3">ท่านได้รับสินค้าส่งคืนจากลูกค้าครบถ้วนและถูกต้องแล้ว ใช่หรือไหม ?</div>-->
                  <!--                <div class="mb-3">สินค้าที่ท่านได้รับคืนจะเข้าสู่คลัง โดยอัตโนมัติเมื่อกดยืนยัน</div>-->
                </v-card-subtitle>
                <div class="text-right mt-8 pb-4">
                  <v-btn height="50" class="white--text grad-success-bg mr-2" type="submit">ยืนยัน</v-btn>
                  <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="confirm_receive_product = false"
                    type="button">ยกเลิก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <!-- แก้ไขใบจัดของ -->
      <v-dialog v-model="edit_bill_lots" persistent max-width="1024">
        <v-card class="rounded-xl" elevation="6">
          <v-form ref="get_lot" @submit.prevent="">
            <div class="d-flex justify-space-between">
              <v-card-title>
                เลือกล็อตสินค้า
              </v-card-title>
              <v-btn icon class="ma-4" @click="edit_bill_lots = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pl-6 pr-6 pb-6">
                <div class="grid_flex" style="font-size: 20px">
                  <div class="grid_flex ma-2">
                    <div class="mr-2">สินค้า :</div>
                    <div>{{ data_edit_bill_lots.product_name }}</div>
                  </div>
                  <div class="grid_flex ma-2">
                    <div class="mr-2">จำนวนในคำสั่งซื้อ :</div>
                    <div>{{ data_edit_bill_lots.refund_quantity }} {{ data_edit_bill_lots.unit_name }}</div>
                  </div>
                </div>
                <div v-if="loading_edit_bill_lots_modal === true">
                  <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                  </v-sheet>
                </div>
                <div v-else>
                  <v-form ref="update_lots" @submit.prevent="lot_change">
                    <v-card-title>
                      <v-text-field v-model="search_data_edit_bill_lots" color="#86bc3a" append-icon="mdi-magnify"
                        label="ค้นหา" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="header_search_data_edit_bill_lots" :items="data_edit_bill_lots.stock_list"
                      :footer-props="footer_Props" :search="search_data_edit_bill_lots" mobile-breakpoint="0">
                      <template v-slot:item="dataDetail">
                        <tr>
                          <td>
                            <div class="text-center">{{ dataDetail.item.lot_no }}</div>
                          </td>
                          <td>
                            <div class="text-center">{{ dataDetail.item.warehouse_date_expired }}</div>
                          </td>
                          <td>
                            <div class="text-center">{{ dataDetail.item.warehouse_quantity }}</div>
                          </td>
                          <td>
                            <div class="text-center">{{ dataDetail.item.unit_name }}</div>
                          </td>
                          <td class="pa-3">
                            <div class="mt-3 mr-1 v-input__slot">
                              <v-text-field color="#86bc3a" type="number" label="จำนวน" min="0"
                                :max="data_edit_bill_lots.refund_quantity" @keypress="isOnlyNumber($event)"
                                @input="quantity_all(dataDetail.item.loop_id, dataDetail.item.quantity)"
                                v-model="dataDetail.item.quantity" required hide-details="auto" outlined></v-text-field>
                            </div>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                    <div class="text-center pt-5">
                      <v-btn large elevation="5" type="submit" style="font-size: 18px"
                        class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
                        บันทึกการแก้ไข
                      </v-btn>
                    </div>
                  </v-form>
                </div>
              </div>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- tracking -->
      <v-dialog v-model="tracking_modal" persistent max-width="700">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                กรุณากรอกเลขที่พัสดุ
              </v-card-title>
              <v-btn icon class="ma-4" @click="tracking_modal = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-form ref="tracking_form" @submit.prevent="tracking_product">
              <v-card-text>
                <v-card-subtitle>
                  <div class="mb-3">ท่านได้ส่งสินค้าชิ้นใหม่ให้ลูกค้าเรียบร้อยแล้ว กรุณากรอกเลขที่พัสดุ</div>
                  <div class="mb-3">
                    <v-text-field color="#86bc3a" label="กรุณากรอกเลขที่พัสดุ"
                      :rules="[v => !!v || 'กรุณากรอกเลขที่พัสดุ']" hide-details="auto" v-model="tracking_number"
                      outlined></v-text-field>
                  </div>
                </v-card-subtitle>
                <div class="text-right mt-8 pb-4">
                  <v-btn height="50" class="white--text grad-success-bg mr-2" type="submit">ยืนยัน</v-btn>
                  <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="tracking_modal = false"
                    type="button">ยกเลิก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
      <!-- refund cash -->
      <v-dialog v-model="refund_to_cash" persistent max-width="600">
        <v-card>
          <div v-if="loading_confirm === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="d-flex justify-space-between">
              <v-card-title>
                กรุณาอัพโหลดหลักฐานการโอนเงิน
              </v-card-title>
              <v-btn icon class="ma-4" @click="refund_to_cash = false">
                <v-icon color="red">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-form ref="refund_form" @submit.prevent="refund_cash">
              <v-card-text>
                <v-card-subtitle>
                  <div class="mb-3">ท่านได้ดำเนินการคืนเงินให้กับลูกค้าเรียบร้อยแล้ว กรุณาอัพโหลดหลักฐานการคืนเงิน</div>
                  <div class="pa-6">
                    <div class="ml-4">
                      <v-img height="300" width="300" max-width="300" v-if="picture_preview !== null"
                        :lazy-src="picture_holder" :src="picture_preview" class="preview mx-auto"></v-img>
                      <v-img height="300" width="300" max-width="300" v-if="picture_preview === null"
                        :lazy-src="picture_holder" :src="picture_holder" class="preview mx-auto"></v-img>
                    </div>
                    <v-file-input color="#86bc3a" accept="image/*" label="รูปภาพหลักฐานการโอนเงิน"
                      :rules="[v => !!v || 'กรุณาอัพโหลดหลักฐานการโอนเงิน']" v-model="picture_transfer"
                      @change="pictureFileChange"></v-file-input>
                    <div v-if="type_refund_price == 1 || type_refund_price == 2">
                      ยอดเงินคืนลูกค้า (บาท) : {{ refund_price }}
                    </div>
                    <v-text-field v-if="type_refund_price == 3 || type_refund_price == 4" color="#86bc3a" type="tel"
                      label="ยอดเงินคืนลูกค้า (บาท)" :rules="[v => !!v || 'ยอดเงินคืนลูกค้า (บาท)']"
                      @keypress="isNumber($event)" v-model="refund_price" required hide-details="auto"
                      outlined></v-text-field>
                  </div>
                </v-card-subtitle>
                <div class="text-right mt-8 pb-4">
                  <v-btn height="50" class="white--text grad-success-bg mr-2" type="submit">ยืนยัน</v-btn>
                  <v-btn height="50" class="white--text grad-danger-bg mr-2" @click="refund_to_cash = false"
                    type="button">ยกเลิก</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-overlay :value="overlay" class="z_index">
      <div class="text-center">
        <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
        <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import img_holder from "@/assets/pharmacy.png";
import { formatNumber, formatPrice, isTelephone } from "@/js/handler";
import picture_holder from "@/assets/picture.png";
import img_checked from "@/assets/checked_refund.png";
import img_time from "@/assets/time_refund.png";
import img_cancel from "@/assets/cancel_refund.png";
import Swal from "sweetalert2";
import { HTTP } from "@/axios";
// import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Refund_detail",
  data() {
    return {
      loading_page: false,
      img_holder: img_holder,
      picture_holder: picture_holder,
      img_checked: img_checked,
      img_time: img_time,
      img_cancel: img_cancel,
      imagePreviewURL: null,
      picture_preview: null,
      picture_transfer: null,
      type_refund_price: null,
      refund_price: null,
      alert_success: false,
      alert_delete: false,
      confirm_modal: false,
      refuse_modal: false,
      confirm_receive_product: false,
      edit_bill_lots: false,
      loading_edit_bill_lots_modal: true,
      search_data_edit_bill_lots: '',
      header_search_data_edit_bill_lots: [
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'warehouse_date_expired',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'warehouse_quantity',
          align: 'center',
          fixed: true,
          width: '200px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          align: 'left',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จำนวนการตัดล็อต',
          value: '',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '200px',
        },
      ],
      data_edit_bill_lots: {
        product_name: null,
        refund_quantity: null,
        unit_name: null,
        stock_list: [],
      },
      tracking_modal: false,
      refund_to_cash: false,
      loading_confirm: false,
      refuse_note: '',
      tracking_number: '',
      overlay: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      warehouse_type: null,
      warehouse_list: [
        { warehouse_id: 1, warehouse_name: 'คลังหลัก' },
        { warehouse_id: 2, warehouse_name: 'คลังใกล้หมดอายุ' },
        { warehouse_id: 3, warehouse_name: 'คลังชำรุด' },
        // {warehouse_id: 4, warehouse_name: 'คลังรอคืน'},
        // {warehouse_id: 5, warehouse_name: 'คลังรอลดหนี้'},
        // {warehouse_id: 6, warehouse_name: 'คลังทิ้ง'},
      ],
      refund: {
        id: null,
        refund_code: null,
        refund_status: null,
        user_type: null,
        user_id: null,
        order_id: null,
        order_code: null,
        refund_reason: null,
        refund_reason_text: null,
        refund_trackin: null,
        picture_lot: null,
        picture_damage: null,
        refund_send: null,
        refund_fix: null,
        refund_delivery: null,
        refund_fix_address: null,
        refund_fix_bank_account_name: null,
        refund_fix_bank_name: null,
        refund_fix_bank_number: null,
        refund_fix_name: null,
        refund_fix_sub_address: null,
        refund_fix_tel: null,
        refund_fix_text: null,
        tracking_number: null,
        user_confirm_id: null,
        user_received_id: null,
        user_transfer_id: null,
        user_complete_id: null,
        user_cancel_id: null,
        cancel_date: null,
        cancel_note: null,
        created_at: null,
        created_date: null,
        updated_at: null,
        slips: null,
      },
      order: {
        id: null,
        order_code: null,
        created_date: null,
      },
      headers: [
        {
          text: 'รายการสินค้าส่งคืน',
          value: '',
          fixed: true,
          sortable: false,
          width: '300px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
        {
          text: 'รวม',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
      ],
      data_list: [],
      headers_list: [
        {
          text: 'รายการสินค้าจากใบจัดของ',
          value: '',
          fixed: true,
          sortable: false,
          width: '300px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
        {
          text: 'รวม',
          value: '',
          fixed: true,
          sortable: false,
          width: '180px',
        },
      ],
      history_list: [],
    }
  },
  methods: {
    async get_data() {
      this.data_list = []
      this.history_list = []
      this.loading_page = true
      await HTTP.post('/refunds/detail', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.refund.id = res.data.refund.id
          this.refund.refund_code = res.data.refund.refund_code
          this.refund.refund_status = res.data.refund.refund_status
          this.refund.created_date = res.data.refund.created_date
          this.refund.refund_reason = res.data.refund.refund_reason
          this.refund.refund_tracking = res.data.refund.refund_tracking
          this.refund.picture_lot = res.data.refund.picture_lot
          this.refund.picture_damage = res.data.refund.picture_damage
          this.refund.refund_fix = res.data.refund.refund_fix
          this.refund.refund_fix_address = res.data.refund.refund_fix_address
          this.refund.refund_fix_bank_account_name = res.data.refund.refund_fix_bank_account_name
          this.refund.refund_fix_bank_name = res.data.refund.refund_fix_bank_name
          this.refund.refund_fix_bank_number = res.data.refund.refund_fix_bank_number
          this.refund.refund_fix_name = res.data.refund.refund_fix_name
          this.refund.refund_fix_sub_address = res.data.refund.refund_fix_sub_address
          this.refund.refund_fix_tel = res.data.refund.refund_fix_tel
          this.refund.refund_fix_text = res.data.refund.refund_fix_text
          this.refund.refund_send = res.data.refund.refund_send
          this.refund.refund_delivery = res.data.refund.refund_delivery
          this.refund.user_confirm_id = res.data.refund.user_confirm
          this.refund.user_received_id = res.data.refund.user_received
          this.refund.user_transfer_id = res.data.refund.user_transfer
          this.refund.user_complete_id = res.data.refund.user_complete
          this.refund.user_cancel_id = res.data.refund.user_cancel
          this.refund.user_type = res.data.refund.user_type
          this.refund.cancel_date = res.data.refund.cancel_date
          this.refund.cancel_note = res.data.refund.cancel_note
          this.refund.tracking_number = res.data.refund.tracking_number
          this.refund.slips = res.data.refund.slips
          this.type_refund_price = res.data.refund.type
          if (res.data.refund.type != 3) {
            this.refund_price = res.data.refund.refund_price
          }
          this.data_list = res.data.refundlist
          this.history_list = res.data.orderlists
          this.order.id = res.data.order.id
          this.order.order_code = res.data.order.order_code
          this.order.created_date = res.data.order.created_date
        }
      }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logout_success')
          this.$router.push('/login')
        }
      })
    },
    pictureFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.picture_preview = null
            this.picture_transfer = null
          })
        } else {
          if (file) {
            this.picture_preview = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.picture_preview = null
          }
        }
      }
      else {
        this.picture_preview = null
        this.picture_transfer = null
      }
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    async claim_confirm() {
      this.overlay = true
      await HTTP.post('/refunds/approve', {
        refund_id: this.refund.id,
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.confirm_modal = false
          this.alert_success = true
          setTimeout(() => this.alert_success = false, 1000)
          this.get_data()
        }
        else {
          this.overlay = false
          this.alert_delete = true
          setTimeout(() => this.alert_delete = false, 3000)
        }
      })
      // setTimeout(() => this.overlay = false, 1000)
    },
    async claim_refuse() {
      if (this.$refs.refuse_form.validate()) {
        this.overlay = true
        await HTTP.post('/refunds/cancel', {
          refund_id: this.refund.id,
          cancel_note: this.refuse_note,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            this.refuse_modal = false
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 1000)
            this.$router.push('/refund/refundprocesssuccess')
          }
          else {
            this.overlay = false
            this.alert_delete = true
            setTimeout(() => this.alert_delete = false, 3000)
          }
        })
      }
    },
    async confirm_product() {
      if (this.$refs.confirm_product.validate()) {
        this.overlay = true
        await HTTP.post('/refunds/receivedrefundproduct', {
          refund_id: this.refund.id,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
          warehouse_type: this.warehouse_type,
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            this.confirm_receive_product = false
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 1000)
            this.get_data()
          }
          else {
            this.overlay = false
            this.alert_delete = true
            setTimeout(() => this.alert_delete = false, 3000)
          }
        })
      }
    },
    print_refund() {
      window.open('https://www.pharmacare-plus.com/profile/envelopPDF/' + this.$route.params.id, '_blank')
      window.open('https://www.pharmacare-plus.com/refundpdfsendship/' + this.refund.refund_code, '_blank')
      window.open('https://www.pharmacare-plus.com/packingsliprefund/' + this.refund.refund_code, '_blank')
    },
    detailEditBillLots() {
      this.loading_edit_bill_lots_modal = true
      this.edit_bill_lots = true
      HTTP.post('/refunds/getlot', {
        refund_id: this.refund.id,
        refund_list_id: this.data_list[0].id,
      })
        .then((res) => {
          if (res.data.success === true) {
            this.data_edit_bill_lots.product_name = res.data.product_name
            this.data_edit_bill_lots.refund_quantity = res.data.refund_quantity
            this.data_edit_bill_lots.unit_name = res.data.unit_name
            for (let index = 0; index < res.data.stock_list.length; index++) {
              res.data.stock_list[index].loop_id = index + 1
              res.data.stock_list[index].old_quantity = res.data.stock_list[index].quantity
              res.data.stock_list[index].total_max = null
            }
            this.data_edit_bill_lots.stock_list = res.data.stock_list
            this.loading_edit_bill_lots_modal = false

          }
        })
    },
    quantity_all(loop_id, qty) {
      let total_qty = 0
      let data_lots = this.data_edit_bill_lots.stock_list
      data_lots.forEach((data) => {
        total_qty += parseInt(data.quantity)
        data.total_max = total_qty
        if (data.loop_id === loop_id) {
          if (data.quantity !== '' && data.quantity !== null) {
            if (parseInt(data.total_max) <= parseInt(this.data_edit_bill_lots.refund_quantity)) {
              data.quantity = parseInt(qty)
              this.get_total_sum = data.total_max
            } else {
              Swal.fire({
                text: 'จำนวนสินค้าต้องไม่เกิน ' + this.data_edit_bill_lots.refund_quantity + ' !',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              }).then(() => {
                data.quantity = data.old_quantity
              })
            }
          }
          else {
            total_qty = null
            data.quantity = null
          }
        }
      })
    },
    lot_change() {
      const value_quantity = this.data_edit_bill_lots.stock_list.reduce((sum, number) => {
        return sum + number.quantity
      }, 0)
      if (value_quantity < this.data_edit_bill_lots.refund_quantity) {
        Swal.fire({
          text: 'จำนวนสินค้ารวมกันต้องไม่น้อยกว่าจำนวนในคำสั่งซื้อ !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      } else {
        this.loading_edit_bill_lots_modal = true
        let data_list = []
        this.data_edit_bill_lots.stock_list.forEach((data) => {
          data_list.push({
            refund_list_stock_id: data.refund_list_stock_id,
            quantity: data.quantity,
          })
        })
        if (this.$refs.update_lots.validate()) {
          HTTP.post('refunds/updatelot', {
            data_list: data_list
          }).then((res) => {
            if (res.data.success === true) {
              this.edit_bill_lots = false
              this.get_data()
            }
          })
        }
      }
    },
    tracking_product() {
      if (this.$refs.tracking_form.validate()) {
        this.overlay = true
        HTTP.post('/refunds/updatetracking', {
          refund_id: this.refund.id,
          user_id: this.$store.state.userDetail.id,
          user_name: this.$store.state.userDetail.name,
          tracking_number: this.tracking_number
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            this.tracking_modal = false
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 1000)
            this.get_data()
          }
          else {
            this.overlay = false
            this.alert_delete = true
            setTimeout(() => this.alert_delete = false, 3000)
          }
        })
        // setTimeout(() => this.overlay = false, 1000)
      }
    },
    refund_cash_partner() {
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      // let formData = {
      //   slip_upload: this.picture_transfer,
      //   refund_price: this.refund_price,
      //   refund_id: this.refund.id,
      //   user_id: this.$store.state.userDetail.id,
      //   user_name: this.$store.state.userDetail.name,
      // };
      let formData = new FormData();
      // formData.append('slip_upload', this.picture_transfer, this.picture_transfer)
      formData.append('refund_price', this.refund_price)
      formData.append('refund_id', this.refund.id)
      formData.append('user_id', this.$store.state.userDetail.id)
      formData.append('user_name', this.$store.state.userDetail.name)
      this.overlay = true
      this.image_modal = false
      HTTP.post('/refunds/upload', formData, config)
        .then((res) => {
          if (res.data.success === true) {
            this.refund_to_cash = false
            this.overlay = false
            this.imagePreviewURL = null
            this.picture_transfer = null
            this.alert_success = true
            setTimeout(() => this.alert_success = false, 1000)
            this.get_data()
          }
        })
    },
    refund_cash() {
      if (this.$refs.refund_form.validate()) {
        // this.refund_to_cash = false
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.picture_transfer.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.picture_transfer = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip_upload', this.picture_transfer, this.picture_transfer.name)
          formData.append('refund_price', this.refund_price)
          formData.append('refund_id', this.refund.id)
          formData.append('user_id', this.$store.state.userDetail.id)
          formData.append('user_name', this.$store.state.userDetail.name)
          this.overlay = true
          this.image_modal = false
          HTTP.post('/refunds/upload', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.refund_to_cash = false
                this.overlay = false
                this.imagePreviewURL = null
                this.picture_transfer = null
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 1000)
                this.get_data()
              }
            })
        }
      }
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_full {
  display: grid;
  grid-template-columns: 100%;
}

.grid_header {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}

.grid_header_2 {
  display: grid;
  grid-template-columns: 70% 30%;
  grid-gap: 15px 0;
}

.grid_flex {
  display: flex;
}

.table_flex {
  display: flex;
  justify-content: space-between;
}

.refund_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}

.image_grid {
  display: grid;
  grid-template-columns: 15% 85%;
}

.image_half {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 15px 0;
}

.margin_auto {
  justify-items: left !important;
}

.grid_issue {
  display: grid;
  grid-template-columns: 30% 70%;
}

.issue_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.btn_mobile {
  width: 20%;
}

.btn_mobile_2 {
  width: auto;
}

.color_table_1>>>thead {
  background-color: #E2F5C7 !important;
}

.color_table_2>>>thead {
  background-color: #FFC804 !important;
}

.mt_mobile {
  margin-top: 10px;
}

@media only screen and (max-width: 1180px) {
  .btn_mobile {
    width: 25%;
  }

  .grid_header {
    display: grid;
    grid-template-columns: 70% 30%;
    grid-gap: 15px 0;
  }

  .grid_header_2 {
    display: grid;
    grid-template-columns: 70% 30%;
    grid-gap: 15px 0;
  }

  .refund_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .image_grid {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .grid_issue {
    display: grid;
    grid-template-columns: 30% 70%;
  }

  .issue_half {
    display: grid;
    grid-template-columns: 40% 60%;
  }
}

@media only screen and (max-width: 1180px) {
  .table_flex {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .font_mobile {
    font-size: 14px !important;
  }

  .mt_mobile {
    margin-top: 15px;
  }

  .font_mobile_2 {
    font-size: 16px !important;
  }

  .mx_auto {
    margin: auto !important;
  }

  .btn_mobile {
    width: 60%;
    margin-top: 15px;
  }

  .image_grid {
    display: grid;
    grid-template-columns: 30% 70%;
  }

  .grid_header {
    display: grid;
    grid-template-columns: 60% 40%;
    grid-gap: 15px 0;
  }

  .grid_header_2 {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .refund_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    font-size: 16px !important;
  }

  .image_half {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .margin_auto {
    margin: auto;
  }

  .grid_issue {
    display: grid;
    grid-template-columns: 100%;
  }

  .issue_half {
    display: grid;
    grid-template-columns: 100%;
  }
}

@media only screen and (max-width: 500px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }

  .table_flex {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
    margin-top: 15px;
  }

  .btn_mobile_2 {
    width: 100%;
    margin-top: 15px;
    font-size: 15px !important;
  }
}
</style>
